<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <h4>{{ invoice.invoice_ref }}</h4>
    <br />
    <h5>
      Date de création :
      <b v-if="invoice.created_at"> {{ getDate(invoice.created_at) }}</b> |
      Store :<b v-if="invoice.client"
        >{{ invoice.client.market_name }} - ({{ invoice.customer_name }} )</b
      >
    </h5>
    <div style="float: right">
      <template v-if="invoice.statut === 0 && invoice.parcels_num != 0">
        <button
          v-if="auth.can('INV')"
          style="margin-right: 4px"
          class="btn btn-primary"
          title="Enregistrer la facture"
          type="button"
          @click="SaveBon()"
        >
          <feather-icon icon="SaveIcon" />
        </button>
      </template>

      <template v-if="invoice.statut === 1 && invoice.parcels_num != 0">
        <button
          style="margin-right: 4px"
          class="btn btn-warning"
          title="Ouvrir la facture"
          type="button"
          @click="UnSaveFact()"
        >
          <feather-icon icon="UnlockIcon" />
        </button>
      </template>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
        v-if="invoice.statut === 0"
      >
        <div class="card-header">
          <h5>Autres frais ( Non Ajoutés )</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="m-2">
            <div class="row">
              <div class="col-md-3">
                <button
                  v-if="invoice.statut === 0"
                  style="margin-right: 12px"
                  class="btn btn-success"
                  type="button"
                  @click="AddNewFees"
                >
                  Ajouter
                </button>
              </div>
              <div class="col-md-9">
                <div class="custom-search d-flex justify-content-end">
                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <input
                        v-model="searchTerm1"
                        placeholder="Chercher"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <vue-good-table
            :columns="ColsFees"
            :rows="ExtraFees"
            :select-options="{
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            }"
            responsive
            :search-options="{
              enabled: true,
              externalQuery: searchTerm1,
            }"
            @select-all="onSelectAllFees"
            @selected-rows-change="selectionChangedFees"
          >
            <!-- <template #emptystate></template> -->
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <template v-if="props.column.field === 'designation'">
                <span>Frais {{ props.row.designation }}</span
                ><br />
              </template>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <div :class="invoice.statut === 0 ? 'col-md-6' : 'col-md-12'">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-header">
          <h5>Autres frais ( Ajoutés )</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="m-2">
            <div class="row">
              <div class="col-md-3">
                <button
                  v-if="invoice.statut === 0"
                  style="margin-right: 12px"
                  class="btn btn-danger"
                  @click="RemoveFeesExtra"
                >
                  Retirer
                </button>
              </div>
              <div class="col-md-9">
                <div class="custom-search d-flex justify-content-end">
                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <input
                        v-model="searchTerm2"
                        placeholder="Chercher"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <vue-good-table
            :columns="ColsFees"
            :rows="ExtraFeesIn"
            :select-options="{
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            }"
            responsive
            style-="table table-hover table-bordered"
            :search-options="{
              enabled: true,
              externalQuery: searchTerm2,
            }"
            @select-all="onSelectRemoveFees"
            @selected-rows-change="selectionChangedNewFees"
          >
            <!-- <template #emptystate></template> -->
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template v-slot:table-row="props">
              <template v-if="props.column.field === 'designation'">
                <span>Frais {{ props.row.designation }}</span
                ><br />
              </template>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
        v-if="invoice.statut === 0"
      >
        <div class="card-header">
          <h5>Factures ( Non Ajouteés )</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="m-2">
            <div class="row">
              <div class="col-md-3">
                <button
                  v-if="invoice.statut === 0"
                  style="margin-right: 12px"
                  class="btn btn-success"
                  @click="AddNewInvcs"
                >
                  Ajouter
                </button>
              </div>
              <div class="col-md-9">
                <div class="custom-search d-flex justify-content-end">
                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <input
                        v-model="searchTerm3"
                        placeholder="Chercher"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <vue-good-table
            :columns="InvsFees"
            :rows="LessExtraInv"
            :select-options="{
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            }"
            responsive
            :search-options="{
              enabled: true,
              externalQuery: searchTerm3,
            }"
            @select-all="onSelectAllInvcs"
            @selected-rows-change="selectionChangedInvcs"
          >
            <!-- <template #emptystate></template> -->
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template v-slot:table-row="props">
              <template v-if="props.column.field === 'total_to_send'">
                <span> {{ props.row.total_to_send }} DH</span><br />
              </template>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing" v-if="invoice.statut === 0">
        <div class="card-header">
          <h5>Factures ( Ajouteés )</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="m-2">
            <div class="row">
              <div class="col-md-3">
                <button
                  v-if="invoice.statut === 0"
                  style="margin-right: 12px"
                  class="btn btn-danger"
                  @click="RemoveNewInvcs"
                >
                  Retirer
                </button>
              </div>
              <div class="col-md-9">
                <div class="custom-search d-flex justify-content-end">
                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <input
                        v-model="searchTerm4"
                        placeholder="Chercher"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <vue-good-table
            :columns="InvsFees"
            :rows="LessExtraInvIn"
            :select-options="{
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            }"
            responsive
            :search-options="{
              enabled: true,
              externalQuery: searchTerm4,
            }"
            @select-all="onSelectRemoveInvcs"
            @selected-rows-change="selectionChangedNewInvcs"
          >
            <!-- <template #emptystate></template> -->
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template v-slot:table-row="props">
              <template v-if="props.column.field === 'total_to_send'">
                <span> {{ props.row.total_to_send }} DH</span><br />
              </template>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="invoice.statut === 0"
  >
    <div class="card-header">
      <h5>Liste des nouveaux colis</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="m-2">
        <div class="row">
          <div
            v-if="auth.can('ADD_INV')"
            class="col-md-3 d-flex justify-content-start mb-1 mb-md-0"
          >
            <button
              v-if="invoice.statut === 0"
              style="margin-right: 12px"
              class="btn btn-success"
              @click="AddNewColis"
            >
              Ajouter
            </button>

            <!-- <v-select
              v-model="users1.per_page"
              :options="[10, 50]"
              :clearable="false"
              class="per-page-selector form-control mx-50"
              @input="getRows1()"
            />
            <label>{{ users1.total }} entités</label> -->
            <!-- <template v-if="invoice.note_saved!=1">
            <button style="border-color: #7367f0 !important;background-color: #7367f0 !important;color: #fff !important;"
                    class="bluecol"
                    @click="SaveReception"
                >
                    Enregister
            </button>
            </template> -->
          </div>
          <div class="col-md-9">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group">
                <div class="d-flex align-items-center">
                  <input
                    v-model="users1.searchTerm"
                    placeholder="Chercher"
                    type="text"
                    class="form-control"
                    @input="getRows1()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        responsive
        @select-all="onSelectAll"
        @selected-rows-change="selectionChanged"
      >
        <!-- <template #emptystate></template> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 v-if="props.row.replace === 1" class="text-warning">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 v-else-if="props.row.partial === 1" class="text-info">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(props.row.status_second)
                  .code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'delivery_time'">
            <span v-if="props.row.delivery_time" class="text-nowrap">
              {{ getDate(props.row.delivery_time) }}
            </span>
            <span v-else class="text-nowrap" />
          </template>

          <template v-else-if="props.column.field === 'pickup_time'">
            <span v-if="props.row.pickup_time" class="text-nowrap">
              {{ getDate(props.row.pickup_time) }}
            </span>
            <span v-else class="text-nowrap" />
          </template>
          <template v-else-if="props.column.field === 'fees'">
            <template
              v-if="
                props.row.status === 'DELIVERED' ||
                props.row.status === 'DELIVERED_PARTIAL'
              "
              ><b>{{ props.row.delivered_fees }}</b> DH</template
            >

            <template
              v-else-if="
                props.row.partial === 1 && props.row.status === 'RETURNED'
              "
            >
              <b>{{ props.row.delivered_fees }} </b> DH
            </template>

            <template
              v-else-if="
                props.row.replace === 1 &&
                (props.row.status === 'RETURNED' ||
                  props.row.status === 'DELIVERED')
              "
            >
              <b>{{ props.row.delivered_fees }} </b> DH
            </template>
            <template
              v-else-if="
                props.row.status != 'DELIVERED' &&
                (props.row.status === 'IN_PROGRESS' ||
                  (props.row.status === 'RETURNED' &&
                    props.row.partial == 0 &&
                    props.row.replace == 0)) &&
                props.row.status_second &&
                props.row.status_second === 'REFUSE'
              "
              ><b>{{ props.row.refused_fees }} </b> DH</template
            >
          </template>

          <template v-else-if="props.column.field === 'total'">
            <template
              v-if="
                props.row.status === 'DELIVERED' ||
                props.row.status === 'DELIVERED_PARTIAL'
              "
              ><b>{{ props.row.price - props.row.delivered_fees }} </b>
              DH</template
            >

            <template
              v-else-if="
                props.row.partial === 1 && props.row.status === 'RETURNED'
              "
            >
              <b>{{ props.row.price - props.row.delivered_fees }} </b> DH
            </template>

            <template
              v-else-if="
                props.row.replace === 1 &&
                (props.row.status === 'RETURNED' ||
                  props.row.status === 'DELIVERED')
              "
            >
              <b>{{ props.row.price - props.row.delivered_fees }} </b> DH
            </template>
            <template
              v-else-if="
                props.row.status != 'DELIVERED' &&
                (props.row.status === 'IN_PROGRESS' ||
                  (props.row.status === 'RETURNED' &&
                    props.row.partial == 0 &&
                    props.row.replace == 0)) &&
                props.row.status_second &&
                props.row.status_second === 'REFUSE'
              "
              ><b>{{ 0 - props.row.refused_fees }} </b> DH</template
            >

            <!-- <template
                  v-if="
                    props.row.status != 'DELIVERED' &&
                      (props.row.status === 'RETURNED' ||
                        props.row.status_second === 'REFUSE')
                  "
                ><b>{{ 0 - props.row.refused_fees }} </b> DH</template> -->
          </template>

          <span v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li
                  v-if="
                    invoice.statut === 0 &&
                    props.row.status != 'INVOICED' &&
                    props.row.status_id != 5 &&
                    props.row.invoiced === 0
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showUpdate(props.row)"
                  >
                    <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                    Modifier Colis
                  </a>
                </li>
                <li
                  v-if="
                    auth.can('PARCELS') &&
                    auth.can('EDIT_PRICE_PARCELS') &&
                    props.row.situation != 'Facturé' &&
                    props.row.situation != 'INVOICED' &&
                    props.row.invoiced != 1
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="openPriceModal(props.row)"
                  >
                    <i class="flaticon-money lh-1 me-8 position-relative top-1"></i>
                    Modifier Prix
                  </a>
                </li>
                <li
                  v-if="
                    auth.can('PARCELS') &&
                    auth.can('EDIT_FEES_PARCELS') &&
                    (user.role_id === 1 || user.role_id === 2) &&
                    props.row.status !== 'NEW_PARCEL' &&
                    props.row.status !== 'WAITING_PICKUP' &&
                    props.row.invoiced === 0
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="handleFeesClick(props.row)"
                  >
                    <i class="flaticon-invoice lh-1 me-8 position-relative top-1"></i>
                    Modifier Frais
                  </a>
                </li>
              </ul>
            </div>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div class="col-md-6" />
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users1"
            :offset="9"
            @paginate="getRows1"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>Liste des colis ajoutés</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="m-2">
        <div class="row">
          <div
            v-if="auth.can('ADD_INV')"
            cols="12"
            md="3"
            class="d-flex justify-content-start mb-1 mb-md-0"
          >
            <button
              v-if="invoice.statut === 0"
              style="margin-right: 12px"
              class="btn btn-danger"
              @click="RemoveNewColis"
            >
              Supprimer
            </button>

            <!-- <v-select
              v-model="users2.per_page"
              :options="[10, 50]"
              :clearable="false"
              class="per-page-selector form-control mx-50"
              @input="getRows2()"
            />
            <label>{{ users2.total }} entités</label> -->
            <!--   <template v-if="Reception.note_saved!=1">
                <button style="border-color: #7367f0 !important;background-color: #7367f0 !important;color: #fff !important;"
                      class="bluecol"
                      @click="SaveReception"
                    >
                      Enregister
                </button>
              </template>-->
          </div>
          <div cols="12" md="9">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group">
                <div class="d-flex align-items-center">
                  <input
                    v-model="users2.searchTerm"
                    placeholder="Chercher"
                    type="text"
                    class="form-control"
                    @input="getRows2()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        responsive
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
      >
        <!-- <template #emptystate></template> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 v-if="props.row.replace === 1" class="text-warning">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 v-else-if="props.row.partial === 1" class="text-info">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                (props.row.status === 'IN_PROGRESS' ||
                  (props.row.status === 'RETURNED' &&
                    props.row.partial == 0 &&
                    props.row.replace == 0)) &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(props.row.status_second)
                  .code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else-if="
                props.row.partial === 1 && props.row.status === 'RETURNED'
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper('DELIVERED').code_color,
              }"
            >
              Livré partiel
            </div>

            <div
              v-else-if="
                props.row.replace === 1 &&
                (props.row.status === 'RETURNED' ||
                  props.row.status === 'DELIVERED')
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper('DELIVERED').code_color,
              }"
            >
              Livré change
            </div>

            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
            <!-- <div  class="rounded-pill fs-13 badge text-bg-black custom-badge " :style="{'--dynamic-bg': props.row.code_color}">{{props.row.s_name}}</div> -->
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'delivery_time'">
            <span v-if="props.row.delivery_time" class="text-nowrap">
              {{ getDate(props.row.delivery_time) }}
            </span>
            <span v-else class="text-nowrap" />
          </template>

          <template v-else-if="props.column.field === 'pickup_time'">
            <span v-if="props.row.pickup_time" class="text-nowrap">
              {{ getDate(props.row.pickup_time) }}
            </span>
            <span v-else class="text-nowrap" />
          </template>
          <template v-else-if="props.column.field === 'fees'">
            <template
              v-if="
                props.row.status_colis === 'DELIVERED' ||
                props.row.status_colis === 'DELIVERED_PARTIAL'
              "
              ><b>{{ props.row.delivered_fees }}</b> DH</template
            >
            <template
              v-if="
                props.row.status_colis != 'DELIVERED' &&
                (props.row.status_colis === 'RETURNED' ||
                  props.row.status_colis === 'REFUSE')
              "
              ><b>{{ props.row.refused_fees }} </b> DH</template
            >
          </template>

          <template v-else-if="props.column.field === 'total'">
            <template
              v-if="
                props.row.status_colis === 'DELIVERED' ||
                props.row.status_colis === 'DELIVERED_PARTIAL'
              "
              ><b>{{ props.row.price - props.row.delivered_fees }} </b>
              DH</template
            >
            <template
              v-if="
                props.row.status_colis != 'DELIVERED' &&
                (props.row.status_colis === 'RETURNED' ||
                  props.row.status_colis === 'REFUSE')
              "
              ><b>{{ 0 - props.row.refused_fees }} </b> DH</template
            >
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div class="col-md-6" />
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users2"
            :offset="9"
            @paginate="getRows2"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Modifier Colis -->
  <div class="modal fade" id="modal_update" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateParcel
            v-if="rowUpdate"
            :rowColis="rowUpdate"
            :getRecords="getRows1"
            :isOpenEdit="isOpenEdit"
            :hideModal="hideModal"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Modifier Prix -->
  <div class="modal fade" id="modal_update_price" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modification du prix de colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="price" class="form-label">Prix</label>
              <input
                id="price"
                v-model="PriceColis.price"
                type="number"
                class="form-control"
                placeholder="Prix du colis"
              />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Annuler
          </button>
          <button type="button" class="btn btn-primary" @click="EditPriceColis">
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Modifier Frais -->
  <div class="modal fade" id="modal_fees_edit" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier les frais</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateFeesParcel
            v-if="rowUpdateFees"
            :rowColis="rowUpdateFees"
            :getRecords="getRows1"
            :isOpenFees="isOpenFees"
            :hideModal="hideModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, nextTick, onMounted, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { useRouter, useRoute } from "vue-router";
import api from "@/utils/axios";
import { useGlobalStore } from "@/stores/global";
import { Modal } from "bootstrap";
import UpdateParcel from "@/components/Colis/UpdateParcel.vue";
import UpdateFeesParcel from "@/components/Colis/UpdateFeesParcel.vue";

export default defineComponent({
  components: { UpdateParcel, UpdateFeesParcel },
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const router = useRouter();
    const route = useRoute();
    const globalStore = useGlobalStore();

    const AgenciesList = ref([]);
    const ClientsList = ref([]);
    const AgencyStockList = ref([]);
    const isLoader = ref(true);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const searchTerm3 = ref("");
    const searchTerm4 = ref("");
    const searchTerm5 = ref("");
    const searchTerm6 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);
    const columns = ref([
      { label: "Code d'envoi", field: "code" },
      { label: "Date de ramassage", field: "pickup_time" },
      { label: "Date de livraison", field: "delivery_time" },
      { label: "Ville", field: "city_name" },
      { label: "Status", field: "status" },
      { label: "Crbt", field: "price" },
      { label: "Frais", field: "fees" },
      { label: "Total", field: "total" },
      { label: "Actions", field: "action" },
    ]);
    const ColsFees = ref([
      { label: "Désignation", field: "designation" },
      { label: "Quantité", field: "qty" },
      { label: "Prix unitaire", field: "price" },
      { label: "Total", field: "total" },
    ]);
    const InvsFees = ref([
      { label: "Référence", field: "invoice_ref" },
      { label: "Colis", field: "parcels_num" },
      { label: "Crbt", field: "total_crbt" },
      { label: "Total", field: "total_to_send" },
    ]);
    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);
    const SelectedRowsBP = ref([]);
    const SelectedNewRowsBP = ref([]);
    const SelectedRowsInvs = ref([]);
    const SelectedNewRowsInvs = ref([]);
    const codeColis = ref("");
    const refReception = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const invoice = ref<any>({});
    const ExtraFees = ref([]);
    const ExtraFeesIn = ref([]);
    const LessExtraInv = ref([]);
    const LessExtraInvIn = ref([]);
    const color = ref("");
    const row = ref({});
    const users1 = ref({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users2 = ref({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const PriceColis = ref<{ id?: number; price?: number }>({});
    const rowFees = ref({});
    const rowUpdate = ref<any>(null);
    const isOpenEdit = ref(false);
    const rowUpdateFees = ref<any>(null);
    const isOpenFees = ref(false);

    // Methods as composition API functions
    function getDate(value: string | number | Date) {
      return value
        ? new Date(value).toLocaleString("fr-FR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })
        : "";
    }

    function hideModal(idModal: string) {
      const modalEl = document.getElementById(idModal);
      if (!modalEl) return;
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      modal.hide();
    }

    function showUpdate(coli: any) {
      rowUpdate.value = null;
      isOpenEdit.value = false;
      rowUpdate.value = { ...coli };
      nextTick(() => {
        const modalEl = document.getElementById("modal_update");
        if (modalEl) {
          isOpenEdit.value = true;
          new Modal(modalEl).show();
        }
      });
    }

    async function ColorStatu(status: string) {
      try {
        const res = await api.get(`/api/auth/ColorStatus?status=${status}`);
        const data = res.data;
        color.value = data;
        return color.value;
      } catch (e) {
        return "";
      }
    }

    async function SearchColis() {
      const data = new FormData();
      data.append("cstmr_id", String(route.params.id));
      data.append("code_colis", codeColis.value);
      isLoader.value = true;
      try {
        const res = await api.post(`/api/auth/SearchColisNote`, data);
        const result = res.data;
        isLoader.value = false;
        if (result.message === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();
        } else if (result.message === "not exist") {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Aucun colis. Vous ne pouvez pas l'ajouter");
        }
      } catch (e) {
        showToast("Oops... Something went wrong! Please try again");
      }
    }

    function onSelectAll(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function selectionChanged(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }
    function onSelectAllFees(params: any) {
      SelectedRowsBP.value = params.selectedRows;
    }
    function selectionChangedFees(params: any) {
      SelectedRowsBP.value = params.selectedRows;
    }
    function onSelectRemoveFees(params: any) {
      SelectedNewRowsBP.value = params.selectedRows;
    }
    function selectionChangedNewFees(params: any) {
      SelectedNewRowsBP.value = params.selectedRows;
    }
    function onSelectAllInvcs(params: any) {
      SelectedRowsInvs.value = params.selectedRows;
    }
    function selectionChangedInvcs(params: any) {
      SelectedRowsInvs.value = params.selectedRows;
    }
    function onSelectRemoveInvcs(params: any) {
      SelectedNewRowsInvs.value = params.selectedRows;
    }
    function selectionChangedNewInvcs(params: any) {
      SelectedNewRowsInvs.value = params.selectedRows;
    }

    // Composition API versions of the methods
    const getData = async () => {
      isLoader.value = true;
      await showInvoice();
      await getRows1();
      await getRows2();
      // ListExtraFees
      await api
        .get(`/api/auth/ListExtraFees`, {
          params: { ref: route.params.refNote },
        })
        .then((res: any) => {
          ExtraFees.value = res.data;
        });
      // ListExtraFeesInInv
      await api
        .get(`/api/auth/ListExtraFeesInInv`, {
          params: { ref: route.params.refNote },
        })
        .then((res: any) => {
          ExtraFeesIn.value = res.data;
        });
      // ListLessExtraInv
      await api
        .get(`/api/auth/ListLessExtraInv`, {
          params: { ref: route.params.refNote },
        })
        .then((res: any) => {
          LessExtraInv.value = res.data;
        });
      // ListLessExtraInInv
      await api
        .get(`/api/auth/ListLessExtraInInv`, {
          params: { ref: route.params.refNote },
        })
        .then((res: any) => {
          LessExtraInvIn.value = res.data;
        });
      isLoader.value = false;
    };

      onMounted(() => {
        getData();
    });

    const showInvoice = async () => {
      await api
        .get(`/api/auth/show_invoice`, {
          params: { ref: route.params.refNote },
        })
        .then((res: any) => {
          invoice.value = res.data.Inv;
        });
    };

    const getRows1 = async (page = 1) => {
      users1.value.current_page = page;
      await api
        .get(
          `/api/auth/list_coli_inv?searchTerm=${users1.value.searchTerm}&page=${users1.value.current_page}&per_page=${users1.value.per_page}`,
          { params: { ref: route.params.refNote } }
        )
        .then((res: any) => {
          rows1.value = res.data.users.data;
          users1.value = res.data.users;
        });
    };

    const getRows2 = async (page = 1) => {
      users2.value.current_page = page;
      await api
        .get(
          `/api/auth/list_coli_in_inv?searchTerm=${users2.value.searchTerm}&page=${users2.value.current_page}&per_page=${users2.value.per_page}`,
          { params: { ref: route.params.refNote } }
        )
        .then((res: any) => {
          rows2.value = res.data.users.data;
          users2.value = res.data.users;
        });
    };

    const AddNewColis = async () => {
      if (SelectedRows.value.length === 0) {
        showToast("Vous pouvez pas ajouter à cette facture", "error");
      } else {
        const data = new FormData();
        data.append("colis", JSON.stringify(SelectedRows.value));
        data.append("note_ref", route.params.refNote as string);
        // loading.value = true;
        await api.post(`/api/auth/Add_colis_to_invc`, data).then((res: any) => {
          if (res.data.message === "success") {
            const audio = new Audio("/sound.mp3");
            audio.play();
            // success notification
            getData();
          } else {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Something went wrong! Please try again", "error");
          }
        });
      }
    };

    const RemoveNewColis = async () => {
      if (SelectedNewRows.value.length === 0) {
        showToast("Vous pouvez pas supprimer à cette facture", "error");
      } else {
        const data = new FormData();
        data.append("colis", JSON.stringify(SelectedNewRows.value));
        data.append("note_ref", route.params.refNote as string);
        await api.post(`/api/auth/remove_colis_invc`, data).then((res: any) => {
          if (res.data.message === "success") {
            const audio = new Audio("/sound.mp3");
            audio.play();
            // success notification
            getData();
          } else {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Something went wrong! Please try again", "error");
          }
        });
      }
    };

    const AddNewFees = async () => {
      if (SelectedRowsBP.value.length === 0) {
        showToast("Vous pouvez pas ajouter à cette facture", "error");
      } else {
        const data = new FormData();
        data.append("fees", JSON.stringify(SelectedRowsBP.value));
        data.append("note_ref", route.params.refNote as string);
        await api.post(`/api/auth/AddFeesToInv`, data).then((res: any) => {
          if (res.data === "success") {
            const audio = new Audio("/sound.mp3");
            audio.play();
            getData();
          } else {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Something went wrong! Please try again", "error");
          }
        });
      }
    };

    const RemoveFeesExtra = async () => {
      if (SelectedNewRowsBP.value.length === 0) {
        showToast("Vous pouvez pas supprimer de cette facture", "error");
      } else {
        const data = new FormData();
        data.append("fees", JSON.stringify(SelectedNewRowsBP.value));
        data.append("note_ref", route.params.refNote as string);
        await api.post(`/api/auth/RemoveFeesInv`, data).then((res: any) => {
          if (res.data === "success") {
            const audio = new Audio("/sound.mp3");
            audio.play();
            getData();
          } else {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Something went wrong! Please try again", "error");
          }
        });
      }
    };

    // Add invoices to invoice
    const AddNewInvcs = async () => {
      if (SelectedRowsInvs.value.length === 0) {
        showToast("Vous pouvez pas ajouter à cette facture", "error");
      } else {
        const data = new FormData();
        data.append("invoices", JSON.stringify(SelectedRowsInvs.value));
        data.append("note_ref", route.params.refNote as string);
        await api.post(`/api/auth/AddInvsToInv`, data).then((res: any) => {
          if (res.data === "success") {
            const audio = new Audio("/sound.mp3");
            audio.play();
            showToast("ajouté avec succès", "success");
            getData();
          } else {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Something went wrong! Please try again", "error");
          }
        });
      }
    };

    // Remove invoices from invoice
    const RemoveNewInvcs = async () => {
      if (SelectedNewRowsInvs.value.length === 0) {
        showToast("Vous pouvez pas ajouter à cette facture", "error");
      } else {
        const data = new FormData();
        data.append("invoices", JSON.stringify(SelectedNewRowsInvs.value));
        data.append("note_ref", route.params.refNote as string);
        await api.post(`/api/auth/RemoveInvsFromInv`, data).then((res: any) => {
          if (res.data === "success") {
            const audio = new Audio("/sound.mp3");
            audio.play();
            showToast("ajouté avec succès", "success");
            getData();
          } else {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Something went wrong! Please try again", "error");
          }
        });
      }
    };

    // Save invoice
    const SaveBon = async () => {
      const confirm = window.confirm("Vous voulez enregistrer cette facture ?");
      if (confirm) {
        await api
          .post(`/api/auth/save_invc/${invoice.value.id}`)
          .then((res: any) => {
            if (res.data.message === "success") {
              showInvoice();
              showToast("Facture bien enregistrée", "success");
            } else if (
              res.data.message === "not exist" ||
              res.data.message === "no parcel"
            ) {
              showToast("Vous pouvez pas enregistré cette facture", "error");
            } else {
              showToast("Un erreur !", "error");
            }
          })
          .catch(() => {
            showToast("Un erreur !", "error");
          });
      }
    };

    // Unsave invoice
    const UnSaveFact = async () => {
      await api
        .post(`/api/auth/unsave_invc/${invoice.value.id}`)
        .then((res: any) => {
          if (res.data.message === "success") {
            showInvoice();
            showToast("Factures est bien modifiée", "success");
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            showToast("Vous pouvez pas modifier cette facture", "error");
          } else {
            showToast("Un erreur !", "error");
          }
        })
        .catch(() => {
          showToast("Un erreur !", "error");
        });
    };

    // Edit parcel price
    const EditPriceColis = async () => {
      const data = new FormData();
      data.append("id_colis", String(PriceColis.value.id));
      data.append("price", String(PriceColis.value.price));
      data.append("user_id", String(user?.id));
      await api
        .post(`/api/auth/coli_edit_price/${PriceColis.value.id}`, data)
        .then((res: any) => {
          if (res.data.message === "success") {
            getRows1();
            showToast("Les données sont bien sauvegardés", "success");
            hideModal("modal_update_price");
          } else if (res.data.message === "no edit") {
            showToast("Vous pouvez pas modifier ce colis", "error");
          } else if (res.data.message === "no access") {
            showToast(
              "Vous avez pas les droits nécessaire pour modifier ce colis",
              "error"
            );
          } else if (res.data.message === "no parcel") {
            showToast("Ce colis est introuvable", "error");
          }
        })
        .catch(() => {
          showToast("Something went wrong! Please try again", "error");
        });
    };

    function openPriceModal(rowData: any) {
      PriceColis.value = rowData;
      nextTick(() => {
        const modalEl = document.getElementById("modal_update_price");
        if (modalEl) new Modal(modalEl).show();
      });
    }

    // Handle fees click
    const handleFeesClick = (rowData: any) => {
      rowUpdateFees.value = null;
      isOpenFees.value = false;
      rowUpdateFees.value = rowData;
      nextTick(() => {
        const modalEl = document.getElementById("modal_fees_edit");
        if (modalEl) {
          isOpenFees.value = true;
          new Modal(modalEl).show();
        }
      });
    };

    return {
      AgenciesList,
      ClientsList,
      AgencyStockList,
      isLoader,
      searchTerm1,
      searchTerm2,
      searchTerm3,
      searchTerm4,
      searchTerm5,
      searchTerm6,
      pageLength,
      pageLength2,
      columns,
      ColsFees,
      InvsFees,
      SelectedRows,
      SelectedNewRows,
      SelectedRowsBP,
      SelectedNewRowsBP,
      SelectedRowsInvs,
      SelectedNewRowsInvs,
      codeColis,
      refReception,
      rows1,
      rows2,
      invoice,
      ExtraFees,
      ExtraFeesIn,
      LessExtraInv,
      LessExtraInvIn,
      color,
      row,
      users1,
      users2,
      PriceColis,
      rowFees,
      rowUpdate,
      isOpenEdit,
      rowUpdateFees,
      isOpenFees,
      hideModal,
      openPriceModal,
      showToast,
      auth,
      user,
      getDate,
      showUpdate,
      ColorStatu,
      SearchColis,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      onSelectAllFees,
      selectionChangedFees,
      onSelectRemoveFees,
      selectionChangedNewFees,
      onSelectAllInvcs,
      selectionChangedInvcs,
      onSelectRemoveInvcs,
      selectionChangedNewInvcs,
      globalStore,
      getData,
      showInvoice,
      getRows1,
      getRows2,
      AddNewColis,
      RemoveNewColis,
      AddNewFees,
      RemoveFeesExtra,
      handleFeesClick,
      AddNewInvcs,
      RemoveNewInvcs,
      SaveBon,
      UnSaveFact,
      EditPriceColis,
    };
  },
});
</script>
  